import { render, staticRenderFns } from "./chatLog.vue?vue&type=template&id=481ebffc&scoped=true&"
import script from "./chatLog.vue?vue&type=script&lang=js&"
export * from "./chatLog.vue?vue&type=script&lang=js&"
import style0 from "./chatLog.vue?vue&type=style&index=0&id=481ebffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481ebffc",
  null
  
)

export default component.exports